import type { AppCopy } from '../catalogs';

export const bgAppCopy = {
  welcomeHeading: 'Как мога да ви помогна днес?',
  thinking: 'Мислене',
  scrollToBottom: 'Превъртете надолу',
  reasoning: 'Разсъждение',
  reasoningInProgress: 'в ход',
  citationPages: 'Страници {first}–{last}',
  citationTitle: 'Откъс от източника',
  citationLoading: 'Зареждане на източника…',
  citationUnavailable: 'Цитираният текст не е наличен или вече нямате достъп.',
  citationOpen: 'Отваряне на източника',
  citationCopied: 'Цитатът е копиран',
  copy: 'копие',
  more: 'повече',
  tryAgain: 'Опитайте отново',
  answerTruncated: 'Отговорът достигна ограничението за дължина и беше прекъснат.',
  continueAnswer: 'Продължи отговора',
  exportMarkdown: 'Експортиране като Markdown',
  edit: 'Редактиране',
  cancel: 'Отказ',
  update: 'Актуализация',
  previous: 'Предишен',
  next: 'Следваща',
  messagePlaceholder: 'Изпратете съобщение...',
  projectHomePlaceholder: 'Нов чат в {project}',
  sharedChatEveryone: 'Всички в {company} могат да четат този чат',
  sharedChatOnePerson: '1 човек може да чете този чат',
  sharedChatPeople: 'Брой хора, които могат да четат този чат: {count}',
  forkedChatPlaceholder: 'Продължете със собствените си връзки…',
  newAnswer: 'Нов отговор',
  messageInput: 'Въвеждане на съобщение',
  sendMessage: 'Изпратете съобщение',
  stopGenerating: 'Спрете да генерирате',
  addAttachment: 'Добавете прикачен файл',
  removeFile: 'Премахване на файл',
  attachmentPreview: 'Визуализация на прикачени файлове',
  imageAttachmentPreview: 'Визуализация на прикачени изображения',
  image: 'Изображение',
  openLink: 'отворен линк',
  document: 'Документ',
  file: 'Файл',
  attachment: 'прикачен файл',
  uploadFailed: 'качването е неуспешно',
  uploading: 'качване',
  toolIncomplete: 'Незавършено',
  toolActivity: 'Дейност',
  activityThinking: 'Мислене…',
  activityWriting: 'Писане…',
  activityWaiting: 'Изчакване на вашето одобрение',
  activityStopped: 'Спряно',
  activityCouldNotFinish: 'Не можа да се завърши',
  activitySources: 'източника',
  activityShowThinking: 'Покажи мисленето',
  activityOpen: 'Отваряне на дейността',
  activitySteps: 'Стъпки',
  activitySourcesTab: 'Източници',
  activityUnavailable: 'Тази дейност не е налична.',
  activityInput: 'Вход',
  activityOutput: 'Резултат',
  activityNoSources: 'Този отговор не цитира източници.',
  activityApprovedByReply: 'Одобрено с вашия отговор',

  toolRunning: 'В процес',
  toolComplete: 'Завършено',
  toolNeedsApproval: 'Изисква одобрение',
  toolInput: 'Входни данни',
  toolCall: 'извикване на инструмент',
  toolCalls: 'извиквания на инструменти',
  openMenu: 'Отворете менюто',
  closeMenu: 'Затваряне на менюто',
  close: 'затвори',
  showInTextField: 'Покажи в текстовото поле',
  settings: 'Настройки',
  appearance: 'Облик',
  themeLight: 'Светла',
  themeDark: 'Тъмна',
  themeSystem: 'Системна',
  themeChoiceHelp:
    'Прилага се на всичките ви устройства. „Системна“ следва светлия или тъмния режим на всяко устройство.',
  themeSaveFailed: 'Обликът не можа да бъде запазен, затова е непроменен. Опитайте отново.',
  toolUsed: 'Използван инструмент',
  toolCancelled: 'Отменен инструмент',
  toolResult: 'Резултат:',
  toolError: 'грешка:',
  toolCancelledReason: 'Причина за анулиране:',
  approvalAllow: 'Разрешете',
  approvalAlwaysAllow: 'Винаги позволявайте',
  approvalDeny: 'Откажи',
  approvalAlwaysDeny: 'Винаги отказвай',
  approvalConfirm: 'Потвърдете',
  approvalBack: 'Назад',
  approvalApprovedResult: 'Одобрено от потребителя',
  approvalDeniedResult: 'Потребителят отказа изпълнение на инструмента',
  logout: 'Излезте',
  loginOrCreateAccount: 'Влезте / Създайте акаунт',
  newChat: 'Нов чат',
  untitledChat: 'Чат без заглавие',
  previousChats: 'Предишни чатове',
  openChat: 'Отворете чата {title}',
  moreActionsForChat: 'Още действия за {title}',
  chatActions: 'Действия в чата',
  closeChatActions: 'Затваряне на чат действия',
  deleteChatQuestion: 'Изтриване на чата?',
  deleteChatDescription: 'Чатът „{title}“ ще бъде изтрит за постоянно.',
  deleteChat: 'Изтрий чата',
  keepChat: 'Запази чата',
  delete: 'Изтриване',
  deleting: 'Изтриване...',
  chatDeleteFailed: 'Чатът не можа да бъде изтрит. Опитайте отново.',
  settingsDescription: 'Персонализирайте начина, по който асистентът работи за вас.',
  settingsDesktopDescription: 'Персонализирайте начина, по който асистентът ви отговаря.',
  personalization: 'Персонализиране',
  personalizationDescription:
    'Персонализирайте инструкциите, които асистентът следва при всеки отговор.',
  languageAndRegion: 'Език и регион',
  languageAndRegionDescription: 'Изберете език и часова зона.',
  memories: 'Спомени',
  memoriesDescription:
    'Преглеждайте, редактирайте или изтривайте това, което асистентът помни за вас.',
  account: 'акаунт',
  accountDescription: 'Управление на акаунта и постоянно изтриване на вашите данни.',
  backToSettings: 'Назад към настройките',
  closeSettings: 'Затворете настройките',
  settingsCategories: 'Категории настройки',
  yourSettings: 'Вашите настройки',
  dataAndAccount: 'Данни и акаунт',
  viewAndManageMemories: 'Преглеждайте и управлявайте какво помни асистентът',
  loginToUseMemories: 'Влезте, за да използвате спомени',
  manageOrDeleteAccount: 'Управлявайте или изтривайте акаунта',
  unsavedChanges: 'Имате незапазени промени',
  unsavedCloseDescription: 'Затварянето на настройките ще отхвърли промените на тази страница.',
  unsavedBackDescription: 'Връщането назад ще отхвърли промените на тази страница.',
  continueEditing: 'Продължете с редактирането',
  discardChanges: 'Отхвърляне на промените',
  saveChanges: 'Запазете промените',
  localSettingsNote: 'Запазено в този браузър. Влезте, за да запазите в акаунта си.',
  personality: 'Личност',
  personalityHelp: 'Персонализирани инструкции, които асистентът следва при всеки отговор',
  personalityPlaceholder:
    'Например: Бъдете кратки и конкретни. Живея в Гьотеборг и харесвам вегетарианска храна.',
  timezone: 'Часова зона',
  searchTimezone: 'Търсене на часови зони...',
  automaticBrowser: 'Автоматично (браузър)',
  saved: 'Запазен {date}',
  addMemory: 'Добави спомен',
  newMemory: 'Нов спомен',
  memoryPlaceholder: 'Например: Предпочитам кратки, конкретни отговори.',
  editMemory: 'Редактирай спомена',
  saveMemory: 'Запази спомена',
  deleteMemory: 'Изтрий спомена',
  memorySaveFailed: 'Паметта не можа да бъде запазена. Опитайте отново.',
  memoryLimitReached: 'Можете да запазите до 50 спомена. Изтрийте един, преди да добавите нов.',
  memoryInvalid: 'Спомените не могат да съдържат връзки. Премахнете връзката и опитайте отново.',
  memoryDeleteFailed: 'Паметта не можа да бъде изтрита. Опитайте отново.',
  memoryLoadFailed: 'Спомените не можаха да бъдат заредени.',
  loadingMemories: 'Спомените се зареждат...',
  emptyMemories:
    'Асистентът запазва спомени за вас, докато говорите – какво харесвате, къде живеете и какво правите. Можете да ги преглеждате, редактирате и изтривате тук.',
  deleteAccountHelp: 'Изтрийте за постоянно акаунта и всички свързани чатове, спомени и настройки.',
  deleteAccount: 'Изтриване на акаунт',
  deleteAccountQuestion: 'Изтриване за постоянно на акаунта?',
  deleteAccountDescription:
    'Всички чатове, съобщения, спомени, настройки и идентификационни данни за вход ще бъдат изтрити. Това действие не може да бъде отменено.',
  deleteAccountConfirm: 'Да, изтрий акаунта ми',
  accountDeleteFailed:
    'Акаунтът не можа да бъде изтрит. Нищо не беше премахнато — опитайте отново.',
  logoutEverywhereTitle: 'Всички устройства',
  logoutEverywhereHelp:
    'Излезте от всички устройства и браузъри, в които акаунтът Ви е отворен, включително това.',
  logoutEverywhere: 'Изход навсякъде',
  logoutEverywhereQuestion: 'Да излезете от всички устройства?',
  logoutEverywhereDescription:
    'Ще трябва да влезете отново на всички устройства и браузъри, включително това. Чатовете и настройките Ви остават непроменени.',
  loggingOut: 'Излизане…',
  logoutEverywhereFailed:
    'Не успяхме да потвърдим, че сте излезли навсякъде. Опитайте отново или проверете на друго устройство дали все още сте влезли.',
  settingsSaveFailed: 'Настройките не можаха да бъдат запазени. Опитайте отново.',
  customInstructions: 'Персонализирани инструкции',
  notSet: 'Не е зададено',
  automaticLanguage: 'Автоматичен език',
  automaticTimezone: 'автоматична часова зона',
  appLanguage: 'Език на приложението',
  appLanguageHelp:
    'Управлява целия интерфейс на приложението и датите. Отговорите на асистента продължават да следват езика, на който пишете.',
  automaticBrowserLanguage: 'Автоматично (език на браузъра)',
  previousLanguageChoice: 'Предишен избор: {language} ({locale})',
  previousLanguageChoiceCode: 'Предишен избор ({locale})',
  canvasCopyLink: 'Копиране на връзката',
  canvasLinkCopied: 'Връзката е копирана',
  actionUpdatedWithEdits: 'Обновено с вашите промени',
  activityStepsDone: 'one:стъпка завършена|other:стъпки завършени',
  activityResultsCount: 'one:резултат|other:резултата',
  canvasCopyLinkFailed: 'Връзката не можа да бъде копирана',
  canvasOpenInAgent: 'Отвори в приложението {agent}',
  canvasExpand: 'Разгъване',
  canvasExitFullView: 'Изход от цял изглед',
  webSourceUnread:
    'Свързано в този отговор. Poneva не е чел тази страница, затова тук няма какво да се покаже.',
  webSourceOpenOriginal: 'Отвори оригинала',
  toolProgressSettings: 'Промяна на настройките ви…',
  toolProgressAgent: 'Създаване на агента…',
  toolProgressConnections: 'Търсене на опции за свързване…',
  toolProgressResult: 'Подготовка на резултата ви…',
  toolProgressClarification: 'Подготовка на уточнение…',
  toolProgressKnowledge: 'Подготовка на предложена актуализация на знанията…',
  toolProgressQuestion: 'Подготовка на въпрос към вас…',
  toolProgressSkill: 'Оформяме вашия Skill…',
  toolErrorSettings: 'Настройките ви не бяха променени.',
  toolErrorAgent: 'Агентът не можа да бъде създаден.',
  toolErrorConnections: 'Опциите за свързване не можаха да бъдат заредени.',
  toolErrorResult: 'Резултатът не беше запазен.',
  toolErrorClarification: 'Уточнението не можа да бъде подготвено.',
  toolErrorKnowledge: 'Предложената актуализация на знанията не можа да бъде подготвена.',
  toolErrorQuestion: 'Въпросът не можа да бъде подготвен.',
  toolErrorSkill: 'Черновата на Skill не можа да бъде запазена.',
  toolErrorOpenSettings: 'Отваряне на Настройки',
  toolErrorOpenAgents: 'Отваряне на Агенти',
  toolErrorOpenConnections: 'Отваряне на Връзки',
  toolStepIncomplete: 'Тази стъпка не беше завършена.',
  toolEarlierAttemptsFailed:
    'one:по-ранен опит не беше успешен|other:по-ранни опита не бяха успешни',
} satisfies AppCopy;
